import React from 'react';
import useAuth from '../hooks/useAuth';

const Home = () => {
    const { user, displayName } = useAuth();

    return (
        <div className="page-container">
            <div className="home-container">
                <h1>Welcome to SquadBot.</h1>
                <h2>{user ? `Hello, ${displayName}` : 'Hello, Guest'}</h2>
            </div>
        </div>
  );
};

export default Home;
